export const GET_CLIENT_NAME = 'GET_CLIENT_NAME'
